import { render, staticRenderFns } from "./SpeakerProfile.vue?vue&type=template&id=3a219a2e&scoped=true&"
import script from "./SpeakerProfile.vue?vue&type=script&lang=js&"
export * from "./SpeakerProfile.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerProfile.vue?vue&type=style&index=0&id=3a219a2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a219a2e",
  null
  
)

export default component.exports